import { Link } from 'react-router-dom';
import { ArrowRight, Clock } from 'lucide-react';
import { motion } from 'framer-motion';

export const CTABanner = () => {
  return (
    <section className="cta-banner" data-testid="cta-banner">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
        className="container-custom"
      >
        <div className="flex items-center justify-center gap-2 mb-4">
          <Clock size={20} className="text-[#FF6B00]" strokeWidth={1.5} />
          <span className="text-[#94A3B8] text-sm uppercase tracking-widest font-bold">
            Urgent Staffing
          </span>
        </div>
        <h2 className="font-['Chivo'] font-black text-3xl md:text-4xl lg:text-5xl text-white mb-4 tracking-tight">
          Need staff urgently?
        </h2>
        <p className="text-[#94A3B8] text-lg md:text-xl mb-8 max-w-2xl mx-auto">
          We can deploy qualified workers within <span className="text-[#FF6B00] font-bold">24 hours</span>.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/employers#request-form"
            className="btn-primary btn-hover-arrow text-lg px-8 py-4"
            data-testid="cta-request-staff"
          >
            Request Staff Now
            <ArrowRight size={20} className="arrow-icon" strokeWidth={2} />
          </Link>
          <Link
            to="/contact"
            className="btn-outline border-white text-white hover:bg-white hover:text-[#0B1F3A] text-lg px-8 py-4"
            data-testid="cta-contact-us"
          >
            Contact Us
          </Link>
        </div>
      </motion.div>
    </section>
  );
};
